import { useCallback } from "react";
import { Address } from "viem";
import { login } from "../../auth";

export const useLogin = () => {
  return useCallback((address: Address, message: string, signature: string) => login(address, message, signature), []);
};
